import React from 'react';
import {roundTo} from 'round-to';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import {formatCurrency} from '../../helpers/currency';
import {isDirectBilling} from '../../helpers/cases';

const getSessionCharge = ({rate, copay, formValues, session}) => {
  const formDiscount = parseFloat(formValues.session_discount);
  const priorDiscount = parseFloat(session.discount);
  const sessionDiscount = (
    !isNaN(formDiscount)
    ? formDiscount
    : (isNaN(priorDiscount) ? 0 : priorDiscount)
  );
  const percentToCharge = (1 - .01 * roundTo(sessionDiscount, 8));
  let total = (
    isDirectBilling(session?.case) && session?.category !== 'optimize'
    ? roundTo(
      parseFloat(copay)
      * percentToCharge,
      2
    )
    : roundTo(
      parseInt(rate, 10)
      * (
        (
          formValues.session_duration
          ? parseInt(formValues.session_duration, 10)
          : parseInt(session.duration, 10)
        ) / 60
      )
      * percentToCharge,
      2
    )
  );
  return total;
};

const BillingCalculator = ({rate, copay, session, formValues}) => {
  const driveTimeFee = (
    formValues.session_drive_time_fee && !isNaN(parseFloat(formValues.session_drive_time_fee))
    ? parseFloat(formValues.session_drive_time_fee)
    : 0
  );
  const sessionCharge = getSessionCharge({rate, copay, formValues, session});
  const total = (
    sessionCharge 
    + driveTimeFee
  );
  return (
    <Box sx={{ backgroundColor: config().colors.background, padding: '0.8rem'}}>
      <Stack>
        <Stack direction='row' alignItems='center' spacing={2} marginBottom={1.5}>
          <Typography variant='paragraphMedium' color='text.light'>
            {isDirectBilling(session?.case) && session?.category !== 'optimize' ? 'Copay:' : 'Provider Rate:'}
          </Typography>
          <Typography variant='paragraphMedium'>
            {
              isDirectBilling(session?.case) && session?.category !== 'optimize'
              ? `${formatCurrency(copay)}`
              : `${formatCurrency(rate)}/hr`
            }
          </Typography>
        </Stack>
        {
          !!formValues.session_drive_time_fee &&
          <Stack direction='row' alignItems='center' spacing={2} marginBottom={1.5}>
            <Typography variant='paragraphMedium' color='text.light'>
              Session Charge:
            </Typography>
            <Typography variant='paragraphMedium'>
              {formatCurrency(sessionCharge)}
            </Typography>
          </Stack>
        }
        {
          !!driveTimeFee &&
          <Stack direction='row' alignItems='center' spacing={2} marginBottom={1.5}>
            <Typography variant='paragraphMedium' color='text.light'>
              Drive Time Fee:
            </Typography>
            <Typography variant='paragraphMedium'>
              {formatCurrency(driveTimeFee)}
            </Typography>
          </Stack>  
        }
        <Stack direction='row' alignItems='center' spacing={2}>
          <Typography variant='paragraphMedium' color='text.light'>
            Total:
          </Typography>
          <Typography variant='paragraphMedium'>
            {formatCurrency(total)}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default BillingCalculator;